import { render, staticRenderFns } from "./LocationFooterNav.vue?vue&type=template&id=5a13601b&scoped=true"
import script from "./LocationFooterNav.vue?vue&type=script&lang=ts"
export * from "./LocationFooterNav.vue?vue&type=script&lang=ts"
import style0 from "./LocationFooterNav.vue?vue&type=style&index=0&id=5a13601b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a13601b",
  null
  
)

export default component.exports